import { createReducer, on } from '@ngrx/store';

import { AuthActions } from '../actions/auth.actions';
import { DealerActions } from '../actions/dealer.actions';
import { FilesActions } from '../actions/files.actions';
import { MessageActions } from '../actions/message.actions';

import { RentActions } from '../actions/rent.actions';
import { BuyActions } from '../actions/buy.actions';

import { KeepActions } from '../actions/keep.actions';
import { CommonActions } from '../actions/common.actions';
import { DealerStoreUtils } from '../store-utils/dealer-store.utils';
import { Dealer } from 'src/app/public/account/models/dealer.model';
import { CarBusinessLine } from 'src/app/public/car/constants/car-basic-data';
import { Car } from 'src/app/public/car/models/car.model';
import { ObjectSource } from 'src/app/public/common/constants/general-basic-data';

export interface DealerState {

    myDealerProfile: Dealer;
    // myDealerProfile: DealerData;

    menuData: { [key: string]: number };

    myCarPark: Car[];

    myCarsToBuy: Car[]; 
    myCarsToRent: Car[];
    myCarsToKeep: Car[];

    fetchingPreview: boolean;
    fetchingResults: boolean;
}

export const initialDealerData: DealerState = {

    myDealerProfile: new Dealer(),
    //myDealerProfile: new DealerData(),

    menuData: {},

    myCarPark: [],

    myCarsToBuy: [],
    myCarsToRent: [],
    myCarsToKeep: [],

    fetchingPreview: false,
    fetchingResults: false
};

export const dealerReducer = createReducer(

    initialDealerData,

    // results fetching true
    on( 
        CommonActions.fetchMyAppointmentsSubmit,
        CommonActions.fetchMyConversationsSubmit,
    
        DealerActions.fetchMyDealerProfileSubmit, 
        DealerActions.updateDealerProfileSubmit, 
    
        DealerActions.fetchMyAlertsSubmit,
        DealerActions.contractFetchAllMySubmit,
        
        DealerActions.fetchMyOwnersSubmit,
        DealerActions.fetchMyProvidersSubmit,
        
        DealerActions.fetchProviderPublicDetailsSubmit,
        
        DealerActions.createNewCarSubmit,
        DealerActions.updateCarSubmit,
        
        DealerActions.fetchCustomerCarsSubmit,
        DealerActions.fetchProviderCarsSubmit,

        CommonActions.fetchMyAppointmentsSubmit,
        CommonActions.fetchMyConversationsSubmit,
        
        //   SearchActions.fetchSameSellerCarsSubmit,
        //   SearchActions.fetchSameSellerCarsSubmit,
        //   SearchActions.dealerCriteriaSubmit,
        //   SearchActions.jobCriteriaSubmit,
        (state) => {
            return {
                ...state,
                fetchingResults: true
            };
        }
    ),


    // results fetching false
    on( 
        CommonActions.fetchMyAppointmentsSuccess,
        CommonActions.fetchMyConversationsSuccess,
    
        DealerActions.fetchMyDealerProfileSuccess, 
        DealerActions.updateDealerProfileSuccess, 
    
        DealerActions.fetchMyAlertsSuccess,
        DealerActions.contractFetchAllMySuccess,
        
        DealerActions.fetchMyOwnersSuccess,
        DealerActions.fetchMyProvidersSuccess,
        
        DealerActions.fetchProviderPublicDetailsSuccess,
        
        DealerActions.createNewCarSuccess,
        DealerActions.updateCarSuccess,
        
        DealerActions.fetchCustomerCarsSuccess,
        DealerActions.fetchProviderCarsSuccess,

        CommonActions.fetchMyAppointmentsSuccess,
        CommonActions.fetchMyConversationsSuccess,

        (state) => {
            return {
                ...state,
                fetchingResults: false
            };
        }
    ),

    // dealer profile

    on( DealerActions.fetchMyDealerProfileSuccess, (state, action) => {
        return {
            ...state, 
            myDealerProfile: action.dealer
        };
    }),

    on( DealerActions.updateDealerProfileSuccess, (state, action) => {
        return {
            ...state,
            myDealerProfile: action.dealer, 
            };
        }
    ),

    on( DealerActions.menuFetchSuccess, (state, action) => {
        return {
            ...state, 
            //menuData: DealerStoreUtils.updateMenu(action.menu)
            menuData: { ...state.menuData, ...action.menu }
        };
    }),

    on( DealerActions.toggleFavoriteProviderSuccess, (state, action) => {

        return {
            ...state,
            myDealerProfile: DealerStoreUtils.toggleFavoriteProvider(state.myDealerProfile, action.providerId, action.makeFav)
       
            };
        
        }
    ),

    on( DealerActions.fetchMyOwnersSuccess, (state, action) => {
        return {
            ...state,
            myDealerProfile: DealerStoreUtils.setMyOwnersInDealer(state.myDealerProfile, action.owners)
       
            };
        }
    ),

    on( DealerActions.fetchMyProvidersSuccess, (state, action) => {
        return {
            ...state,
            myDealerProfile: DealerStoreUtils.setMyProvidersInDealer(state.myDealerProfile, action.providers)
       
            };
        }
    ),

    // dealer cars

    on( DealerActions.fetchParkSuccess,
        DealerActions.fetchProviderCarsSuccess,
        (state, action) => {
        return {
            ...state,
            myCarPark: action.cars
        };
    }),


    on( DealerActions.fetchCustomerCarsSuccess, (state, action) => {

        switch(action.businessLine){
            case CarBusinessLine.BUY: {
                return {
                    ...state,
                    myCarsToBuy: action.cars.map(x => Object.assign(new Car(), x)),
                };
            }

            case CarBusinessLine.RENT:{
                return {
                    ...state,
                    myCarsToRent: action.cars.map(x => Object.assign(new Car(), x)),
                };
            }

            case CarBusinessLine.KEEP:{
                return {
                    ...state,
                    myCarPark: action.cars.map(x => Object.assign(new Car(), x)),
                };
            }

            default: {
                return {
                    ...state,
                };
            }
        }  
    }),

    on( DealerActions.createNewCarSuccess, (state, action) => {
        return {
            ...state,
            myCarPark: DealerStoreUtils.addCar (state.myCarPark, action.car),
            };
        }
    ),

    on( DealerActions.updateCarSuccess, (state, action) => {
        return {
            ...state,
           myCarPark: DealerStoreUtils.updateCar (state.myCarPark, action.car), 
            };
        }
    ),

    on( FilesActions.uploadCarImageFileDataSuccess, (state, action) => {
        
        return {
            ...state,
            myCarPark: DealerStoreUtils.updateCar (state.myCarPark, action.car),
        };
        
    }),

    on( DealerActions.deleteCarSuccess, (state, action) => {
        return {
            ...state,
            myCarPark: DealerStoreUtils.deleteCar(state.myCarPark, action.carId)
            };
        }
    ),

    on( DealerActions.createNewCarPriceSuccess, (state, action) => {
        return {
            ...state,
            myCarPark: DealerStoreUtils.addCarPrice(state.myCarPark, action.carId, action.businessLine, action.price)
            };
        }
    ),

    on( DealerActions.createNewCarOfferSuccess, (state, action) => {

        return {
            ...state,
            //myFavoriteCars: DealerStoreUtils.addCarOffer(state.myFavoriteCars, action.carId, action.offer)
            };
        }
    ),

    on( DealerActions.toggleFavoriteSuccess, (state, action) => {

        switch(action.businessLine.toString()) {
            case CarBusinessLine.BUY.toString(): {

                return {
                    ...state,
                    myCarsToBuy: DealerStoreUtils.toggleFavorite(state.myCarsToBuy, action.objectId, action.objectClass, action.makeFav)
                    //myCarsToBuy: action.makeFav ? DealerStoreUtils.addFavorite(state.myCarsToBuy, action.objectId, action.objectClass): DealerStoreUtils.removeFavorite(state.myCarsToBuy, action.car.carId)
                };
            }
    
            case CarBusinessLine.RENT.toString(): {
                return {
                    ...state,
                    myCarsToRent: DealerStoreUtils.toggleFavorite(state.myCarsToRent, action.objectId, action.objectClass, action.makeFav)
                    //myCarsToRent: action.makeFav ? DealerStoreUtils.addFavorite(state.myCarsToRent, action.car): DealerStoreUtils.removeFavorite(state.myCarsToRent, action.car.carId)  
                };
            }
    
            case CarBusinessLine.KEEP.toString(): {
                return {
                    ...state,
                    myCarPark: DealerStoreUtils.toggleFavorite(state.myCarPark, action.objectId, action.objectClass, action.makeFav)
                    //myCarPark: action.makeFav ? DealerStoreUtils.addFavorite(state.myCarPark, action.car): DealerStoreUtils.removeFavorite(state.myCarPark, action.car.carId)
                };
            }
    
            default: {
                return {
                    ...state,
                };
            }
        }
    }),


    // Provider Offer

    on( DealerActions.providerOfferUpsertSuccess, (state, action) => {

        if(action.objectSource === ObjectSource.PARK){
            return {
                ...state,
                myCarPark: DealerStoreUtils.upsertProviderOfferInPark(state.myCarPark, action.providerOffer)
            };
        }

        switch(action.providerOffer.businessLine) {
            case CarBusinessLine.BUY: {

                return {
                    ...state,
                    myCarsToBuy: DealerStoreUtils.upsertProviderOffer(state.myCarsToBuy, action.providerOffer)
                };
            }
    
            case CarBusinessLine.RENT: {
                return {
                    ...state,
                    myCarsToRent: DealerStoreUtils.upsertProviderOffer(state.myCarsToRent, action.providerOffer) 
                };
            }
    
            case CarBusinessLine.KEEP: {
                return {
                    ...state,
                    myCarPark: DealerStoreUtils.upsertProviderOffer(state.myCarPark, action.providerOffer)
                };
            }
    
            default: {
                return {
                    ...state,
                };
            }
        }
    }),

    on( DealerActions.providerOfferDeleteSuccess, (state, action) => {

        if(action.objectSource === ObjectSource.PARK){
            return {
                ...state,
                myCarPark: DealerStoreUtils.deleteProviderOfferInPark(state.myCarPark, action.carId, action.providerOfferId, action.businessLine)
            };
        }

        switch(action.businessLine) {
            case CarBusinessLine.BUY: {

                return {
                    ...state,
                    myCarsToBuy: DealerStoreUtils.deleteProviderOffer(state.myCarsToBuy, action.providerOfferId)
                };
            }
    
            case CarBusinessLine.RENT: {
                return {
                    ...state,
                    myCarsToRent: DealerStoreUtils.deleteProviderOffer(state.myCarsToRent, action.providerOfferId)
                };
            }
    
            case CarBusinessLine.KEEP: {
                return {
                    ...state,
                    myCarPark: DealerStoreUtils.deleteProviderOffer(state.myCarPark, action.providerOfferId)
                };
            }
    
            default: {
                return {
                    ...state,
                };
            }
        }
    }),

    on( DealerActions.providerOffersFetchMySuccess, (state, action) => {

        switch(action.businessLine.toString()) {
            case CarBusinessLine.BUY.toString(): {

                return {
                    ...state,
                    myCarsToBuy: action.providerOffers
                };
            }
    
            case CarBusinessLine.RENT.toString(): {
                return {
                    ...state,
                    myCarsToRent: action.providerOffers  
                };
            }
    
            case CarBusinessLine.KEEP.toString(): {
                return {
                    ...state,
                    myCarPark: action.providerOffers
                };
            }
    
            default: {
                return {
                    ...state,
                };
            }
        }
    }),


    // Keep Offer

    on( DealerActions.keepOfferUpsertSuccess, (state, action) => {

        if(action.objectSource === ObjectSource.DEALER){
            return {
                ...state,
                myDealerProfile: DealerStoreUtils.upsertKeepOfferInDealer(state.myDealerProfile, action.keepOffer)
            };
        }
        else{
            return {
                ...state
            };
        }
    }),

    // Toggle business car status

    on( DealerActions.toggleCarBusinessLineStatusSuccess, (state, action) => {

        console.log("status red = "+action.status+ ", Line = "+action.businessLine+ "id = "+action.carId)
        return {
            ...state,
            myCarPark: DealerStoreUtils.toggleBusinessLineStatus(state.myCarPark, action.carId, action.status, action.businessLine)
       
            };
        }
    ),

    on( DealerActions.updateCarStatusSuccess, (state, action) => {
        return {
            ...state,
            myCarPark: DealerStoreUtils.updateCarStatus(state.myCarPark, action.carId, action.status)
            };
        }
    ), 

    // dealer alerts

    on( DealerActions.addNewAlertSuccess, (state, action) => {
        return {
            ...state,
            myDealerProfile: DealerStoreUtils.addAlert(state.myDealerProfile, action.alert)
       
            };
        }
    ),

    on( DealerActions.alertUpdateSuccess, (state, action) => {
        return {
            ...state,
            myDealerProfile: DealerStoreUtils.updateAlert(state.myDealerProfile, action.alert)
       
            };
        }
    ),

    on( DealerActions.alertDeleteSuccess, (state, action) => {
        return {
            ...state,
            myDealerProfile: DealerStoreUtils.deleteAlert(state.myDealerProfile, action.alertId)
       
            };
        }
    ),

    on( DealerActions.fetchMyAlertsSuccess, (state, action) => {
        return {
            ...state,
            myDealerProfile: DealerStoreUtils.setAlerts(state.myDealerProfile, action.alerts)
       
            };
        }
    ),

    // messages

    on( MessageActions.sendNewMessageSuccess, (state, action) => {

        switch(action.objectSource){
            case ObjectSource.DEALER : {
                return {
                    ...state,
                    myDealerProfile: DealerStoreUtils.updateConversationInDealer(state.myDealerProfile, action.conversation)
                };
                break;  
            }
            case ObjectSource.PARK : {
                return {
                    ...state,
                    myCarPark: DealerStoreUtils.updateConversationInCar(state.myCarPark, action.conversation)
                };
                break;
            }
            case ObjectSource.BUY : {
                return {
                    ...state,
                    myCarsToBuy: DealerStoreUtils.updateConversationInCar(state.myCarsToBuy, action.conversation)

                };
                break;
            }
            case ObjectSource.RENT : {
                return {
                    ...state,
                    myCarsToRent: DealerStoreUtils.updateConversationInCar(state.myCarsToRent, action.conversation)
                };
                break;
            }
            case ObjectSource.KEEP : {
                return {
                    ...state,
                    myCarPark: DealerStoreUtils.updateConversationInCar(state.myCarPark, action.conversation)
                };
                break;
            }

            default : {
                return {
                    ...state,
                    myDealerProfile: DealerStoreUtils.updateConversationInDealer(state.myDealerProfile, action.conversation)
                };
                break;
            }
        }
    }), 
    /* 
    on( MessageActions.replyMessageSuccess, (state, action) => {
            
        return {
            ...state,
            myCarPark: DealerStoreUtils.addMessageToConversation(state.myCarPark, action.carId, action.conversationId, action.message),
            //myFavoriteCars: DealerStoreUtils.addMessageToConversation(state.myFavoriteCars, action.carId, action.conversationId, action.message)
            };
        }
       
    ),

    on( MessageActions.fetchMessagesSuccess, (state, action) => {
        return {
            ...state,
            myDealerProfile: DealerStoreUtils.updateAllMessages(state.myDealerProfile, action.messages)
       
            };
        }
    ),
    */

    // proposals
    /** 
    on( BuyActions.proposalNewSuccess, (state, action) => {
        return {
            ...state,
            myCarPark: DealerStoreUtils.addProposal(state.myCarPark, action.proposal),
            myCarsToBuy: DealerStoreUtils.addProposal(state.myCarsToBuy, action.proposal),
            //myFavoriteCars: DealerStoreUtils.addProposal(state.myFavoriteCars, action.carId, action.proposal)
       
            };
        }
    ),
    
    on( BuyActions.proposalUpdateSuccess, (state, action) => {
        return {
            ...state,
            myCarPark: DealerStoreUtils.updateProposal(state.myCarPark, action.proposal),
            myCarsToBuy: DealerStoreUtils.updateProposal(state.myCarsToBuy, action.proposal),
            //myFavoriteCars: DealerStoreUtils.updateProposal(state.myFavoriteCars, action.carId, action.index, action.proposal)
       
            };
        }
    ),
    */
    on( BuyActions.proposalUpsertSuccess, (state, action) => {
        switch(action.objectSource){
            case ObjectSource.DEALER : {
                return {
                    ...state,
                    myDealerProfile: DealerStoreUtils.upsertProposalInDealer(state.myDealerProfile, action.proposal)
                };
                break; 
            }
            case ObjectSource.PARK : {
                return {
                    ...state,
                    myCarPark: DealerStoreUtils.upsertProposalInCar(state.myCarPark, action.proposal),
                };
                break;
            }
            case ObjectSource.BUY : {
                return {
                    ...state,
                    myCarsToBuy: DealerStoreUtils.upsertProposalInCar(state.myCarsToBuy, action.proposal)
                };
                break;
            }
            case ObjectSource.RENT : {
                return {
                    ...state,
                    myCarsToRent: DealerStoreUtils.upsertProposalInCar(state.myCarsToRent, action.proposal)
                };
                break;
            }

            case ObjectSource.KEEP : {
                return {
                    ...state,
                    myCarPark: DealerStoreUtils.upsertProposalInCar(state.myCarPark, action.proposal)
                };
                break;
            }
            default : {
                return {
                    ...state,
                    myDealerProfile: DealerStoreUtils.upsertProposalInDealer(state.myDealerProfile, action.proposal)
                };
                break;
            }
        }  
    }),

    //appointments

    on( CommonActions.appointmentUpsertSuccess, (state, action) => {
        switch(action.objectSource){
            case ObjectSource.DEALER : {
                return {
                    ...state,
                    myDealerProfile: DealerStoreUtils.upsertAppointmentInDealer(state.myDealerProfile, action.appointment)
                };
                break;
            }
            case ObjectSource.PARK : {
                return {
                    ...state,
                    myCarPark: DealerStoreUtils.upsertAppointmentInCar(state.myCarPark, action.appointment)
                };
                break;
            }
            case ObjectSource.BUY : {
                return {
                    ...state,
                    myCarsToBuy: DealerStoreUtils.upsertAppointmentInCar(state.myCarsToBuy, action.appointment)

                };
                break;
            }
            case ObjectSource.RENT : {
                return {
                    ...state,
                    myCarsToRent: DealerStoreUtils.upsertAppointmentInCar(state.myCarsToRent, action.appointment)
                };
                break;
            }
            case ObjectSource.KEEP : {
                return {
                    ...state,
                    myCarPark: DealerStoreUtils.upsertAppointmentInCar(state.myCarPark, action.appointment)
                };
                break;
            }
            default : {
                return {
                    ...state,
                    myDealerProfile: DealerStoreUtils.upsertAppointmentInDealer(state.myDealerProfile, action.appointment)
                };
                break;
            }
        }  
    }),

    on( CommonActions.fetchMyAppointmentsSuccess, (state, action) => {
        return {
            ...state,
            myDealerProfile: DealerStoreUtils.setAppointmentsInDealer(state.myDealerProfile, action.appointments)
       
            };
        }
    ),

    //conversations

    on( CommonActions.fetchMyConversationsSuccess, (state, action) => {
        return {
            ...state,
            myDealerProfile: DealerStoreUtils.setConversationsInDealer(state.myDealerProfile, action.conversations)
       
            };
        }
    ),

    //contracts

    /*
    on( DealerActions.contractNewSuccess, (state, action) => {
        return {
            ...state,
            myDealerProfile: DealerStoreUtils.addContractInDealer(state.myDealerProfile, action.contract),

            };
        }
    ),
    */
    on( DealerActions.contractUpsertSuccess, (state, action) => {
        return {
            ...state,
            myDealerProfile: action.objectSource !== ObjectSource.SEARCH ? DealerStoreUtils.upsertContractInDealer(state.myDealerProfile, action.contract) : state.myDealerProfile,
            };
        }
    ),

    on( DealerActions.contractDeleteSuccess, (state, action) => {
        return {
            ...state,
            myDealerProfile: action.objectSource !== ObjectSource.SEARCH ? DealerStoreUtils.deleteContractInDealer(state.myDealerProfile, action.contractId) : state.myDealerProfile,
            };
        }
    ),

    on( DealerActions.contractFetchAllMySuccess, (state, action) => {
        return {
            ...state,
            myDealerProfile: DealerStoreUtils.setContractsInDealer(state.myDealerProfile, action.contracts)
       
            };
        }
    ),

    // Jobs

    /*
    on( KeepActions.jobNewSuccess, (state, action) => {
        return {
            ...state,
            myCarPark: DealerStoreUtils.addJob(state.myCarPark, action.job),
      
            };
        }
    ),
    

    on( KeepActions.jobUpsertSuccess, (state, action) => {
        return {
            ...state,
            myCarPark: DealerStoreUtils.updateJob(state.myCarPark, action.job),
      
            };
        }
    ),
    */

    on( KeepActions.jobUpsertSuccess, (state, action) => {
        switch(action.objectSource){
            case ObjectSource.DEALER : {
                return {
                    ...state,
                    myDealerProfile: DealerStoreUtils.upsertJobInDealer(state.myDealerProfile, action.job)
                };
                break;
            }
            case ObjectSource.PARK : {
                return {
                    ...state,
                    myCarPark: DealerStoreUtils.upsertJobInCar(state.myCarPark, action.job)
                };
                break;
            }
            case ObjectSource.BUY : {
                return {
                    ...state,
                    myCarsToBuy: DealerStoreUtils.upsertJobInCar(state.myCarsToBuy, action.job)

                };
                break;
            }
            case ObjectSource.RENT : {
                return {
                    ...state,
                    myCarsToRent: DealerStoreUtils.upsertJobInCar(state.myCarsToRent, action.job)
                };
                break;
            }
            case ObjectSource.KEEP : {
                return {
                    ...state,
                    myCarPark: DealerStoreUtils.upsertJobInCar(state.myCarPark, action.job)
                };
                break;
            }
            default : {
                return {
                    ...state,
                    myDealerProfile: DealerStoreUtils.upsertJobInDealer(state.myDealerProfile, action.job)
                };
                break;
            }
        }  
    }),


    
    on( KeepActions.postingUpsertSuccess, (state, action) => {
        switch(action.objectSource){
            case ObjectSource.DEALER : {
                return {
                    ...state,
                    //myDealerProfile: DealerStoreUtils.upsertJobInDealer(state.myDealerProfile, action.job)
                };
                break;
            }
            case ObjectSource.PARK : {
                return {
                    ...state,
                    myCarPark: DealerStoreUtils.upsertPostingInCar(state.myCarPark, action.posting)
                };
                break;
            }
            case ObjectSource.BUY : {
                return {
                    ...state,
                    //myCarsToBuy: DealerStoreUtils.upsertJobInCar(state.myCarsToBuy, action.job)
                };
                break;
            }
            case ObjectSource.RENT : {
                return {
                    ...state,
                    //myCarsToRent: DealerStoreUtils.upsertJobInCar(state.myCarsToRent, action.job)
                };
                break;
            }
            case ObjectSource.KEEP : {
                return {
                    ...state,
                    myCarPark: DealerStoreUtils.upsertPostingInCar(state.myCarPark, action.posting)
                };
                break;
            }
            default : {
                return {
                    ...state,
                    //myDealerProfile: DealerStoreUtils.upsertJobInDealer(state.myDealerProfile, action.job)
                };
                break;
            }
        }  
    }),


    //bookings
    /* 
    on( RentActions.bookingNewSuccess, (state, action) => {
        return {
            ...state,
            myCarPark: DealerStoreUtils.addBookingInCar(state.myCarPark, action.booking),
            myCarsToRent: DealerStoreUtils.addBookingInCar(state.myCarsToRent, action.booking),
            //myFavoriteCars: DealerStoreUtils.addBooking(state.myFavoriteCars, action.booking)
       
            };
        }
    ),

    on( RentActions.bookingUpdateSuccess, (state, action) => {
        return {
            ...state,
            myCarPark: DealerStoreUtils.updateBookingInCar(state.myCarPark, action.updatedBooking),
            myCarsToRent: DealerStoreUtils.updateBookingInCar(state.myCarsToRent, action.updatedBooking),
            //myFavoriteCars: DealerStoreUtils.updateBooking(state.myFavoriteCars, action.updatedBooking)
       
            };
        }
    ),

    on( RentActions.bookingStatusUpdateSuccess, (state, action) => {

        return {
            ...state,
            myCarPark: DealerStoreUtils.updateBookingInCar(state.myCarPark, action.updatedBooking),
            myCarsToRent: DealerStoreUtils.updateBookingInCar(state.myCarsToRent, action.updatedBooking)
            };
        }
    ),
    */
    on( RentActions.bookingUpsertSuccess, (state, action) => {
        switch(action.objectSource){
            case ObjectSource.DEALER : {
                return {
                    ...state,
                    myDealerProfile: DealerStoreUtils.upsertBookingInDealer(state.myDealerProfile, action.booking)
                };
                break;
            }
            case ObjectSource.PARK : {
                return {
                    ...state,
                    myCarPark: DealerStoreUtils.upsertBookingInCar(state.myCarPark, action.booking)
                };
                break;
            }
            case ObjectSource.BUY : {
                return {
                    ...state,
                    myCarsToBuy: DealerStoreUtils.upsertBookingInCar(state.myCarsToBuy, action.booking)

                };
                break;
            }
            case ObjectSource.RENT : {
                return {
                    ...state,
                    myCarsToRent: DealerStoreUtils.upsertBookingInCar(state.myCarsToRent, action.booking)
                };
                break;
            }
            case ObjectSource.KEEP : {
                return {
                    ...state,
                    myCarPark: DealerStoreUtils.upsertBookingInCar(state.myCarPark, action.booking)
                };
                break;
            }
            default : {
                return {
                    ...state,
                    myDealerProfile: DealerStoreUtils.upsertBookingInDealer(state.myDealerProfile, action.booking)
                };
                break;
            }
        }  
    }),

    // logout

    on( AuthActions.logoutSubmit, (state) => {
        
        localStorage.removeItem("token");
        
        return {
            ...state,
            myDealerProfile: new Dealer(),
            //myDealerProfile: new DealerData(),
            menuData: {},
            myCarPark: [],

            myCarsToBuy: [],
            myCarsToRent: [],
            myCarsToKeep: [],  
            jobs: [],
        };
    }),

    //on(reset, (state) => 0)
);


// selectors
//export const selectAllSearchedCars = (state: SearchState) => state.searchedCars;
//export const selectAllSearchedCarsCount = (state: SearchState) => state.searchedCars.length;


//export const selectMyFavoriteCars = (state: DealerState) => state.myFavoriteCars;
//export const selectMyFavoriteCarBriefs = (state: DealerState) => state.myFavoriteCarBriefs;
//export const selectDealerCarFavoritesIds = (state: DealerState) => state.myDealerProfile;

export const selectCustomerCars = (state: DealerState, businessLine: CarBusinessLine) => {
    switch(businessLine.toString()) {
        case CarBusinessLine.BUY.toString(): {
            return state.myCarsToBuy;
        }

        case CarBusinessLine.RENT.toString(): {
            return state.myCarsToRent;
        }

        case CarBusinessLine.KEEP.toString(): {
            return state.myCarPark;
        }

        default: {
            return [];
        }
    }     
}

// selectors

export const selectDealerFetchingPreview = (state: DealerState) => state.fetchingPreview;
export const selectDealerFetchingResults = (state: DealerState) => state.fetchingResults;

// utility functions


    